import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import QCNote from "./qcNote";
import { 
  Alert,
  Col,
  Button,
  Row,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  UncontrolledTooltip,
  CustomInput,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";
import { useFetch } from "../utils/fetchHook";
import {  useLocation } from "react-router-dom";
import { getCookie } from "../jwt/_helpers/cookie";
import TableHelper from "../components/tableHelper";
import { StateContext } from "../utils/context";
import { getUser } from "../utils/getUser";
import TracksUpdate from "../views/tracks/tracksUpdate";
import { Trans, useTranslation } from "react-i18next";
import flaggedContentPng from "../assets/images/flaggedContent.png"
import EscrowPaymentModal from "./escrowPaymentModal";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const pagination = paginationFactory({
  sizePerPageList: [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 }
  ]
});

const TracksTable = () => {
  const { SearchBar, ClearSearchButton } = Search;
  const {currentUser, setCurrentUser} = useContext(StateContext);
  const token = getCookie("token");
  const location = useLocation();
  const currentID = location.pathname.split("/")[2];

  const { t } = useTranslation();

  const [selectedTrackToEdit, setTrackToEdit] = useState(false);
  const [successPATCH, successPATCHset] = useState(false);

  const [forceUpdate, forceUpdateSET] = useState(0);;

  const [data, error, loading] = useFetch("GET",`releases/${currentID}/`,token,false,forceUpdate);
  const [dataGenres] = useFetch( "GET", `genres/`, token, false);
  const [appVariables] = useFetch("GET", "app-variables/", token, false, forceUpdate);
  const [contributorRoles] = useFetch( "GET", `contributor-roles/`, token, false);
  const [shareholderRoles] = useFetch( "GET", `shareholder-roles/`, token, false);

  const [allTracksReady, setAllTracksReady] = useState(false);
  const [releaseStatus, setReleaseStatus] = useState("");
  const [openDistribute, setOpenDistribute] = useState(false);
  const [openFinishEditing, setOpenFinishEditing] = useState(false);
  const [todUrl, setTodUrl] = useState('#');
  const [touUrl, setTouUrl] = useState('#');
  const [ppUrl, setPpUrl] = useState('#');
  const [redirect, setRedirect] = useState(false);

  const [artificialStreamingDeclaration, artificialStreamingDeclarationSET] = useState(false);
  const [escrowPaymentModalOpen, setEscrowPaymentModalOpen] = useState(false);

  const { acr_deep_scan } = currentUser;

  const [pre_scan_done, pre_scan_doneSET] = useState(false);
  const [pre_scan_status, pre_scan_statusSET] = useState(false);
  const [pre_scan, pre_scanSET] = useState(false);

  const [distributionDisabledPreScanNotDone, distributionDisabledPreScanNotDoneSET] = useState(false);
  const [distributionDisabledPreScanInProgress, distributionDisabledPreScanInProgressSET] = useState(false);
  const [distributionDisabledPreScanDeclarationNotSubmitted, distributionDisabledPreScanDeclarationNotSubmittedSET] = useState(false);

  const toggleescrowPaymentModal = () => setEscrowPaymentModalOpen(!escrowPaymentModalOpen);

  function rowHighlightStyle(row, rowIndex) {
    let hasQCFeedback = !row.qc_passed && !row.edited_after_qc;
    if (hasQCFeedback) {
      return "qc-issues-alert";
    }
    return "";
  }

  const setSuccessEdit = () => {
    successPATCHset(true);
    setTimeout(() => {
      successPATCHset(false);
    }, 3000);
  };

  const updateState = {
    forceUpdate,
    forceUpdateSET
  };
  const onEditClick = id => {
    setTrackToEdit(id);
    [].forEach.call(document.querySelectorAll("tbody tr"), function(el) {
      el.classList.remove("activeRow");
    });
    document
      .querySelector(`#rowEdit_${id}`)
      .closest("tr")
      .classList.add("activeRow");
  };

  const actionFormatter = (cell, row) => {
    return (
      <Button
        outline
        color="primary"
        id={`rowEdit_${row.id}`}
        onClick={() => onEditClick(row.id)}
      >
        {t("tracks.view.table.button.edit")}
      </Button>
    );
  };
  const mixFormatter = (cell, row) => (cell ? cell : "-");
  const nameFormatter = (cell, row) => <span className="fontWeight700">{cell}</span>;

  const lenghtFormatter = (cell, row) => {
    if (!cell) {
      return '';
    }
    let base = cell;
    let splited = base.split(":");
    splited[splited.length -1]  = splited[splited.length -1 ].substring(0,2)
    const newCell = splited.join(":");
    return newCell;
  };


  const trackCompleteFormatter = cell => {
    return (
      <>
        {cell ? (
          <Button className="btn-status" disabled color="success">
            {t("tracks.view.table.button.statusReady")}
          </Button>
        )
        :
          (
          <Button className="btn-status" disabled color="warning">
            {t("tracks.view.table.button.statusNotReady")}
          </Button>
        )}
      </>
    );
  };

  const trackAccStatusFormatter = cell => {
    return (
      <>
        {cell ? (
          <span className="p-4">
            <i className="fas fa-2x fa-check-circle text-success"></i>
          </span>
        )
        :
          (
            <span className="p-4">
              <i className="fas fa-2x fa-times-circle text-danger"></i>
            </span>
        )}
      </>
    );
  };

  const audioPlayerFormatter = (cell, row) => {
    const trackRes = cell && cell.length > 0 ? cell : row.resource;
    const trackType = cell && cell.length > 0 ? "audio/mp3" : "audio/wav";
    return (
      <audio
        controls
        id={'track_play_' + row.id}
        controlsList="nodownload"
        onPlay={() => handlePlayClick(row.id)}
      >
        <source src={trackRes} type={trackType} />
        {t("tracks.view.table.message.browserNotSupported")}
      </audio>
    )
  };

  const handlePlayClick = (id) => {
    const trArray = document.querySelectorAll('[id^="track_play_"]');
    trArray.forEach((audio) => {
      if ( !audio.paused && audio.id !== `track_play_${id}`){
        audio.pause();
      }
    });
  };

  const qcNoteFormatter = (cell, row) => {
    return (
      <QCNote {...row} noteType={"Track"}></QCNote>
    );
  };

  const distributeRelease = (ID) => {
    axios({
      method: "patch",
      mode: 'cors',
      url: `${API_URL}releases/${ID}/`,
      data: {
        status: "approval"
      },
      headers: {
        Authorization: `JWT ${token}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      if (response.status === 200) {
        getUser(token, currentUser, setCurrentUser);
        setOpenDistribute(false);
        setRedirect(true);
      }
    });
  };

  const submitRedeliveryEditing = (ID) => {
    axios({
      method: "patch",
      mode: 'cors',
      url: `${API_URL}releases/${ID}/`,
      data: {
        status: "re_delivery-delivery"
      },
      headers: {
        Authorization: `JWT ${token}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      if (response.status === 200) {
        getUser(token, currentUser, setCurrentUser);
        setOpenFinishEditing(false);
        setRedirect(true);
      }
    });
  };

  const patchRelease = (ID, status) => {
    axios({
      method: "patch",
      mode: 'cors',
      url: `${API_URL}releases/${ID}/`,
      data: {
        status: status
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      if (response.status === 200) {
        forceUpdateSET(forceUpdate + 1);
      }
    });
  };

  useEffect(() => {
    if(data.all_tracks_ready) {
      setAllTracksReady(true);
    }
    if (data.all_tracks_ready && data.status === "offline") {
      patchRelease(data.id, "ready");
    }
    if(data.status) {
      setReleaseStatus(data.status);
    }

    if(data.pre_scan) {
      pre_scanSET(data.pre_scan);
    }
    if(data.pre_scan_done) {
      pre_scan_doneSET(data.pre_scan_done);
    }
    if(data.pre_scan_status) {
      pre_scan_statusSET(data.pre_scan_status);
    }
  }, [data]);

  useEffect(() => {
    const pre_scan_alert = pre_scan && pre_scan?.alert;
    const pre_scan_scanned_tracks = pre_scan && pre_scan?.scanned_tracks.length > 0;
    const preScanDeclarationRequired = pre_scan_done && pre_scan_alert && pre_scan_scanned_tracks;
    const preScanDeclarationSubmitted = pre_scan?.admin_declaration != null;

    distributionDisabledPreScanNotDoneSET(acr_deep_scan && !pre_scan_done);
    distributionDisabledPreScanInProgressSET(acr_deep_scan && pre_scan_done && pre_scan_status === "in_progress");
    distributionDisabledPreScanDeclarationNotSubmittedSET(acr_deep_scan && pre_scan_status === "completed" && preScanDeclarationRequired && !preScanDeclarationSubmitted);
  }, [acr_deep_scan, pre_scan, pre_scan_done, pre_scan_status]);

  useEffect(() => {
    if (appVariables) {
      if(appVariables) {
        setTodUrl(appVariables['terms-of-distribution-url']);
        setTouUrl(appVariables['terms-of-use-url']);
        setPpUrl(appVariables['privacy-policy-url']);
      }
    }
  }, [appVariables]);

  const columns = [
    {
      dataField: "name",
      text: t("tracks.view.table.column.name"),
      sort: true,
      formatter: nameFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "190px" };
      }
    },
    {
      dataField: "mix_name",
      text: t("tracks.view.table.column.mixName"),
      sort: true,
      formatter: mixFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "135px" };
      }
    },
    {
      dataField: "track_lenght",
      text: t("tracks.view.table.column.mixLength"),
      sort: true,
      formatter: lenghtFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "135px" };
      }
    },
    {
      dataField: "mp3_resource",
      text: t("tracks.view.table.column.player"),
      sort: false,
      csvExport: false,
      formatter: audioPlayerFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "333px" };
      }
    },
    {
      dataField: "track_data_complete",
      text: t("tracks.view.table.column.status"),
      sort: true,
      csvExport: false,
      formatter: trackCompleteFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "track_ready_for_accounting",
      text: t("tracks.view.table.column.accStatus"),
      sort: true,
      csvExport: false,
      formatter: trackAccStatusFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "135px" };
      }
    },
    {
      dataField: "qc",
      text: t("tracks.view.table.column.qc"),
      formatter: qcNoteFormatter,
      sort: false,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      }
    },
    {
      dataField: "action",
      text: t("tracks.view.table.column.action"),
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "111px" };
      }
    },
  ];

  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <CardTitle tag="h4">{t("tracks.view.table.title")}</CardTitle>
              {loading ? (
                <TableHelper loading />
              ) : error ? (
                <TableHelper error />
              ) : (
                <ToolkitProvider
                  keyField={"order"}
                  data={data.tracks}
                  columns={columns}
                  search={{
                    searchFormatted: true
                  }}
                  exportCSV
                >
                  {props => (
                    <div className="tracksTable">
                      <Row>
                        <Col>
                          <div className="customSearch">
                            <SearchBar {...props.searchProps} />
                            <ClearSearchButton
                              className="customClear"
                              text="x"
                              {...props.searchProps}
                            />
                          </div>
                        </Col>
                      </Row>
                      <BootstrapTable
                        rowClasses={rowHighlightStyle}
                        {...props.baseProps}
                        bordered={ false }
                        pagination={pagination}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>

      { !selectedTrackToEdit &&
        <Row className="float-right mr-1 mb-5">
          <Button className="btn btn-ml" onClick={setRedirect}>{t("tracks.view.table.button.goToReleases")}</Button>
          {
            releaseStatus === "ready" && <>
              <Button
                id={`restrdis-tooltip-${currentID}`}
                className="btn btn-success ml-2"
                disabled={!allTracksReady || (!currentUser.is_sub_user && !currentUser.identity_checked) || distributionDisabledPreScanInProgress || distributionDisabledPreScanNotDone || distributionDisabledPreScanDeclarationNotSubmitted}
                onClick={() => {
                  if(data.has_flagged_tracks && !data.is_light_whitelisted && !data.escrow_payment_declined) {
                    setEscrowPaymentModalOpen(true);
                  } else {
                    setOpenDistribute(true);
                  }
                }}
              >
                {t("tracks.view.table.button.distribute")}
                {distributionDisabledPreScanInProgress || distributionDisabledPreScanNotDone || distributionDisabledPreScanDeclarationNotSubmitted}
              </Button>
              {(!allTracksReady || (!currentUser.is_sub_user && !currentUser.identity_checked) || distributionDisabledPreScanInProgress || distributionDisabledPreScanNotDone || distributionDisabledPreScanDeclarationNotSubmitted) && (
              <UncontrolledTooltip
                placement="top"
                trigger="hover"
                target={`restrdis-tooltip-${currentID}`}
              >
                {
                  (!currentUser.is_sub_user && !currentUser.identity_checked) && <>
                    {t("tracks.view.table.message.identityNotCheckedTooltip")}
                    <br/><br/>
                  </>
                }

                {
                  !allTracksReady && <>
                    {t("tracks.view.table.message.tracksNotReadyTooltip")}
                    <br/><br/>
                  </>
                }

                {
                  (distributionDisabledPreScanInProgress) && <>
                    {t("tracks.view.table.message.distributionDisabledPreScanInProgressTooltip")}
                    <br/><br/>
                  </>
                }

                {
                  (distributionDisabledPreScanNotDone) && <>
                    {t("tracks.view.table.message.distributionDisabledPreScanNotDoneTooltip")}
                    <br/><br/>
                  </>
                }

                {
                  (distributionDisabledPreScanDeclarationNotSubmitted) && <>
                    {t("tracks.view.table.message.distributionDisabledPreScanDeclarationNotSubmittedTooltip")}
                    <br/><br/>
                  </>
                }
              </UncontrolledTooltip>
            )}
            </>
          }
          {
            releaseStatus === "re_delivery-editing" && <>
              <Button
                id={`restrse-tooltip-${currentID}`}
                className="btn btn-success ml-2"
                disabled={!allTracksReady}
                onClick={setOpenFinishEditing}>
                  {t("tracks.view.table.button.submitEditing")}
              </Button>
              {!allTracksReady && (
                <UncontrolledTooltip
                  placement="top"
                  trigger="hover"
                  target={`restrse-tooltip-${currentID}`}
                >
                  {t("tracks.view.table.message.tracksNotReadyForEditingTooltip")}
                </UncontrolledTooltip>
              )}
            </>
          }
        </Row>
      }

      <Modal isOpen={openDistribute} centered={true} style={{ maxWidth: '70%' }}>
        <ModalHeader>{t("tracks.view.table.modal.distribute.header")}</ModalHeader>
        <ModalBody>
          <p><Trans i18nKey="tracks.view.table.modal.distribute.body.point1">After this action, your release will be checked and if the information is correct it will be distributed on the official and exclusive distribution dates.</Trans></p>
          <p><Trans i18nKey="tracks.view.table.modal.distribute.body.point2">By confirming and accepting this form, you are fully accepting and complying with the <a href={todUrl} target="blank" rel="noopener noreferrer">Terms Of Distribution</a>, <a href={touUrl} target="blank" rel="noopener noreferrer">Terms Of Use</a> and <a href={ppUrl} target="blank" rel="noopener noreferrer">Privacy Policy</a>.</Trans></p>
          <p><Trans i18nKey="tracks.view.table.modal.distribute.body.point3">By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.</Trans></p>
          <p><Trans i18nKey="tracks.view.table.modal.distribute.body.point4">Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute.</Trans></p>

          {
            (data.has_flagged_tracks && !data.is_light_whitelisted) &&
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                flexWrap: 'wrap'
              }}
            >
              <div style={{ flex: '1 1 300px' }}>
                <h6><u>{t("tracks.view.table.modal.distribute.body.flaggedTracksTerms.header")}</u></h6>
                <Trans i18nKey="tracks.view.table.modal.distribute.body.flaggedTracksTerms.point1" values={{ releaseName: data.name }}>
                  Please note: <strong>"{data.name}"</strong> contains one or more flagged tracks, A fee of <strong>15 €</strong> per flagged track applies in order to deliver the release to <strong>Spotify</strong>. As you have opted not to pay this fee at this time, the release will not be delivered to Spotify. By confirming and accepting this form, you acknowledge and accept these terms.
                </Trans>
                <br/><br/>

                <Trans i18nKey="tracks.view.table.modal.distribute.body.flaggedTracksTerms.point2">
                  In future if you opt for the release to be delivered to <strong>Spotify</strong> you can go to the Flagged section in Releases table and follow the payment prompts.
                </Trans>
              </div>

              <div style={{ flex: '1 1 300px' }}>
                <img
                  alt="flagged content"
                  src={flaggedContentPng}
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',      
                    maxHeight: '200px',
                  }}
                />
              </div>
            </div>
          }

          <div className="mt-4">
            <h6><u>{t("tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.header")}</u></h6>
            <p><Trans i18nKey="tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.point1"><strong>1.</strong> I fully understand and agree not to engage in any form of artificial streaming, including the use of bots, streaming farms, or any method that manipulates DSP metrics.</Trans></p>
            <p><Trans i18nKey="tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.point2"><strong>2.</strong> I will not pay or offer payment for playlist placements, nor will I work with any third party promising guaranteed placements — I understand this is considered fraud and a scam.</Trans></p>
            <p><Trans i18nKey="tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.point3"><strong>3.</strong> I acknowledge that any such actions may result in immediate termination, forfeiture of royalties, legal claims, contractual penalties and fees, and reporting to DSPs and authorities.</Trans></p>
            <p><Trans i18nKey="tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.point4"><strong>4.</strong> I also guarantee to inform and educate any artists or clients I work with about these rules and ensure they comply.</Trans></p>
            <p><Trans i18nKey="tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.point5"><strong>5.</strong> I understand that if I engage in artificial streaming, my KYC data, including my full name, address, ID card, and other personal information, can be shared with the DSP's legal departments, such as those of Spotify, Apple Music, and others.</Trans></p>
            <p><Trans i18nKey="tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.point6"><strong>6.</strong> I accept full legal responsibility for any violations.</Trans></p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <CustomInput
                type="checkbox"
                id="artificialStreamingDeclaration"
                name="artificialStreamingDeclaration"
                checked={artificialStreamingDeclaration}
                value={artificialStreamingDeclaration}
                onChange={(e) => { artificialStreamingDeclarationSET(!artificialStreamingDeclaration)}}
              />
              <h6 className="mt-2">
                {t("tracks.view.table.modal.distribute.body.artificialStreamingDeclaration.acknowledgment")}
              </h6>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setOpenDistribute(false)}>
            {t("tracks.view.table.modal.distribute.button.cancel")}
          </Button>
          <Button color="success" onClick={() => distributeRelease(currentID)} disabled={!artificialStreamingDeclaration}>
            {t("tracks.view.table.modal.distribute.button.confirm")}
          </Button>
        </ModalFooter>
      </Modal>

      <EscrowPaymentModal
        modalOpen={escrowPaymentModalOpen}
        setModalOpen={setEscrowPaymentModalOpen}
        toggleModal={toggleescrowPaymentModal}
        id={data.id}
        name={data.name}
        flagged_tracks={data.flagged_tracks}
        escrow_payment_declined={data.escrow_payment_declined}
        forceUpdate={forceUpdate}
        setForceUpdate={forceUpdateSET}
        openDistributeModal={true}
        setOpenDistributeModal={setOpenDistribute}
      />

      <Modal isOpen={openFinishEditing} centered={true}>
      <ModalHeader>{t("tracks.view.table.modal.finishEditing.header")}</ModalHeader>
        <ModalBody>
          <p><Trans i18nKey="tracks.view.table.modal.finishEditing.body.point1">After this action, your release will be checked and if the information is correct it will be re-distributed to the DSP partners. <strong>NOTE, only METADATA will be sent to DSP-s, content such as IMAGE and AUDIO files can not be updated this way.</strong></Trans></p>
          <p><Trans i18nKey="tracks.view.table.modal.finishEditing.body.point2">By confirming and accepting this form, you are fully accepting and complying with the <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms Of Use</a> and Terms of our Exclusive Distribution Agreement.</Trans></p>
          <p><Trans i18nKey="tracks.view.table.modal.finishEditing.body.point3">By confirming and accepting this form, you are fully accepting and complying with the <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</Trans></p>
          <p><Trans i18nKey="tracks.view.table.modal.finishEditing.body.point4">By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.</Trans></p>
          <p><Trans i18nKey="tracks.view.table.modal.finishEditing.body.point5">Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute.</Trans></p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setOpenFinishEditing(false)}>
            {t("tracks.view.table.modal.finishEditing.button.cancel")}
          </Button>
          <Button color="success" onClick={() => submitRedeliveryEditing(currentID)}>
            {t("tracks.view.table.modal.finishEditing.button.confirm")}
          </Button>
        </ModalFooter>
      </Modal>

      {selectedTrackToEdit && (
        <TracksUpdate
          releaseData={data}
          id={selectedTrackToEdit}
          data={{
            dataGenres: dataGenres,
            contributorRoles,
            shareholderRoles
          }}
          updateState={updateState}
          setTrackToEdit={() => setTrackToEdit()}
          setSuccessEdit={() => setSuccessEdit()}
        />
      )}

      {successPATCH && (
        <Alert style={{ paddingTop: 20 }} color="success">
          {t("tracks.view.table.message.trackUpdated")}
        </Alert>
      )}
      {redirect ? <Redirect to="/releases" /> : null}
    </>
  );
};

export default TracksTable;
